import { ApiKey } from "../interfaces/api-key";
import { createDBServiceSlice } from "./db-service-reducers"; // Add missing import statement

export const {
    slice: ApiKeysSlice,
    dbThunks: _ApiKeysThunks,
    selectByQuery: _apiKeysSelectByQuery,
    selectOneObjectByQuery: _apiKeysSelectOneObjectByQuery,
    selectOneFieldByQuery: _apiKeysSelectOneFieldByQuery,
    selectors: _apiKeysSelectors,
    selectByQueryOnlyLength: _apiKeysSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _apiKeysSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<ApiKey>({
    service: "api-keys",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBApiKeysReducer,
});
export const DBApiKeysReducer = ApiKeysSlice.reducer;
export const ApiKeysReducerActions = ApiKeysSlice.actions;
export type apiKeysReducerActions = keyof typeof ApiKeysReducerActions;
export const DBApiKeysThunks = _ApiKeysThunks;
export const apiKeysSelectors = _apiKeysSelectors;
export const apiKeysSelectByQuery = _apiKeysSelectByQuery;
export const apiKeysSelectByQueryOnlyLength = _apiKeysSelectByQueryOnlyLength;
export const apiKeysSelectByQueryOnlyMaxMin = _apiKeysSelectByQueryOnlyMaxMin;
export const apiKeysSelectOneObjectByQuery = _apiKeysSelectOneObjectByQuery;
export const apiKeysSelectOneFieldByQuery = _apiKeysSelectOneFieldByQuery;
